import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import panZoom from 'vue-panzoom'
import VueAnalytics from 'vue-analytics'
import Vue2TouchEvents from 'vue2-touch-events'
import Landing from './components/Landing'
import Questions from './components/Questions'
import Mixing from './components/Mixing'
import Results from './components/Results'
import ResultsList from './components/ResultsList'
import ResultsGallery from './components/ResultsGallery'
import OneMoreThing from './components/OneMoreThing'
import store from './store'
import VueGtm from 'vue-gtm';

Vue.use(Vue2TouchEvents)

Vue.use(VueAnalytics, {
  id: 'UA-40488596-17'
})

Vue.config.productionTip = false
Vue.use(panZoom)
Vue.use(VueRouter)

Vue.use(VueGtm, {
  id: 'GTM-NV5BH9', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  queryParams: {},
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
});

const routes = [
  { path: '/small', redirect: () => ({
      name: 'landing',
      query: { wall: 'small', access: 'qr' },
    }),
  },
  { path: '/large', redirect: () => ({
      name: 'landing',
      query: { wall: 'large', access: 'qr' },
    }),
  },
  { path: '/', component: Landing, name: "landing", meta: { title: "British Paints Colour Wall" } },
  { path: '/questions', component: Questions, name: "questions" },
  { path: '/mixing', component: Mixing, name: "mixing" },
  { path: '/results', component: Results, name: "results" },
  { path: '/results-list', component: ResultsList, name: "resultsList" },
  { path: '/results-gallery', component: ResultsGallery, name: "resultsGallery", props: true },
  { path: '/one-more-thing', component: OneMoreThing, name: "oneMoreThing", props: true },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

// If the page doesn't exist, default to signin page.
router.beforeResolve(( to, from, next ) => {
  if ( to.matched.length === 0 ) {
    next('/')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if ((from.query.access && !to.query.access) || (from.query.wall && !to.query.wall)) {
    if (to.path === from.path) {
      return
    } 
    router.push({name: to.name, params: to.params, query: { access: from.query.access, wall: from.query.wall }})
  } else {
    next()
  }
})

Vue.filter('colourTitleHtml', (colourName) => {
  return colourName.replace(/®/gi, '<sup>®</sup>')
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')